import { render, staticRenderFns } from "./Hirek.vue?vue&type=template&id=cc5efc3e&"
import script from "./Hirek.vue?vue&type=script&lang=js&"
export * from "./Hirek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports